import { ANGLE_MAP } from '@ui/icons/utils/icon-direction'
import { withDirectionalStatics } from '@ui/icons/utils/withDirectionalStatics'

export const ArrowIcon = withDirectionalStatics((props) => {
  const { size, color, direction = 'up' } = props
  const rotation = ANGLE_MAP[direction] ?? 0

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <g transform={`rotate(${rotation} 12 12)`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L18.7071 10.2929C19.0976 10.6834 19.0976 11.3166 18.7071 11.7071C18.3166 12.0976 17.6834 12.0976 17.2929 11.7071L13 7.41421V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V7.41421L6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929L11.2929 4.29289Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
